<script>
  	import { onMount } from 'svelte';
	import { Router, Route, Link, navigate } from "svelte-routing";
	import {
		Button,
		ButtonGroup,
		Alert,
		Modal,
		ModalBody,
		ModalFooter,
		ModalHeader,
		Icon,
		Input,
		Popover,
		Card,
		CardBody,
		CardFooter,
		CardHeader,
		CardSubtitle,
		CardText,
    		CardTitle } from 'sveltestrap';
    	import { Textfield } from 'svelte-mui';
	import { api_url, path } from "../ConfigService.js";
	import Loading from "../components/Loading.svelte";
	import ImgDialog from "../components/imgDialog.svelte";
	import MediaQuery from "../components/MediaQuery.svelte";
	import MenuItem from "../components/menuItem.svelte";
	import NumberSpinner from "../components/numberSpinner.svelte";
	import ConfirmDialog from "../components/confirmDialog.svelte";
	import SendEmail from "../components/SendEmail.svelte";
	import Zasilkovna from "../components/Zasilkovna.svelte";
	import Imgupload from '../components/Imgupload.svelte';
	import DeleteOrder from "../components/deleteOrder.svelte";
	import Tooltip from "../components/Tooltip.svelte";

	export let id;
	export let orderno;
	export let token;
	export let selectedFile=false;
	export let selectedFileId=false;
	export let selectedSkupinova="0";
	export let countOfProduct=0;
	export let addToCartCount=0;
	export let img;
	export let checkboxes=[];
	export let selectedData=false;
	export let openConfirmDialog=false;
	export let SendMailOpen=false;
	export let deleteOrderOpen=false;
	export let needUpdate=false;
	export let dataCart;
	export let success=false;

	export let material="mat";
	export let varId = {
	    '10x15': 1,
	    '13x18': 2,
	    '15x20': 3,
	    '20x30': 4
	  };

	export let data = (async () => {
		 const resp = await fetch($api_url+'?album=last&key='+orderno);
		 let d=resp.json();
		 changeMaterial(material, await d);
		 return await d;
	})()
	
	async function updateData() {
		const resp = await fetch($api_url + '?album=last&key=' + orderno);
  		data=await resp.json();
  		changeMaterial(material, await data);
		needUpdate=false;
	}

	function openOrder() {
		navigate('/photos/'+orderno);
		updateData();
	}
	  
	const handleOpenOrder = () => {
		openOrder();
	}
	
	async function changeMaterial(m, d) {
		localStorage.setItem('material', m);
		dataCart = null;
		const resp = await fetch($api_url+'changeMaterial.php?material='+m+'&album=last&key=' + orderno);
	  	data = await resp.json();
		
		if(d) {
			try {
				if(d.config.shop.materials[m]) {
					varId=d.config.shop.materials[m];
				}
			} catch (error) {
				//console.error("Chyba:", error.message);
			}
		}
	}

	function removeSuffix(name) {
			name=name.split("/");
			name=name.slice(-1)[0].replaceAll(".jpg", "");
			name=name.replaceAll(".jpeg", "");
			name=name.replaceAll(".JPG", "");
			return name;
	}

	function onRightClick(e) { return false; }

	function getMaxPrintSize(pxWidth, pxHeight, dpi = 300) {
		if(pxWidth === null) { return 999; }
		const maxWidthInInches = pxWidth / dpi;
		const maxHeightInInches = pxHeight / dpi;

		const maxWidthInCm = maxWidthInInches * 2.54;
		const maxHeightInCm = maxHeightInInches * 2.54;

		if(maxWidthInCm.toFixed(2)>maxHeightInCm.toFixed(2)) { return maxWidthInCm.toFixed(2); }
		return maxHeightInCm.toFixed(2);
	}
	
	function approximateFraction(r, tolerance = 0.01, maxDenom = 100) {
		let bestNumerator = 1;
		let bestDenom = 1;
		let bestError = Math.abs(r - bestNumerator / bestDenom);

		for (let d = 1; d <= maxDenom; d++) {
			let n = Math.round(r * d);
			let error = Math.abs(r - n / d);
			if (error < bestError) {
				bestError = error;
				bestNumerator = n;
				bestDenom = d;
			}
			if (error < tolerance) {
				break;
			}
		}
		return { numerator: bestNumerator, denominator: bestDenom };
	}

	function getAspectRatio(pxWidth, pxHeight) {
		const ratio = pxWidth / pxHeight;
		const approx = approximateFraction(ratio, 0.01, 100);
		if(approx.denominator>approx.numerator) { return `${approx.denominator}:${approx.numerator}`; }
		return `${approx.numerator}:${approx.denominator}`;
	}

	
	function calcPriceFromCart(d) {
		let price=0;
		if(d.cart) {
			for(let i=0; i<d.cart.length; i++) {
				//console.log(d.cart[i].price);
				price+=parseInt(d.cart[i].price);
			}
		}
		return price;
	}
	
	function calcPrice(c, d) {
		if(c) { 
			return calcPriceFromCart(c);
		} else if(d) {
			return calcPriceFromCart(d);
		}
		return "";
	}
	
	function isSelected(photo, v, d, dc) {
		if(dc) {
			if(dc.cart) {
				for(let i=0; i<dc.cart.length; i++) {
					if(parseInt(dc.cart[i].id)==parseInt(photo) && parseInt(dc.cart[i].type)==parseInt(v)) { return "selected"; }				
				}
			}
		} else if(d) {
			if(d.cart) {
				for(let i=0; i<d.cart.length; i++) {
					if(parseInt(d.cart[i].id)==parseInt(photo) && parseInt(d.cart[i].type)==parseInt(v)) { return "selected"; }				
				}
			}
		}
		return "";
	}
	
	function getCountFromCart(photo, v, d) {
		if(d) {
			if(d.cart) {
				for(let i=0; i<d.cart.length; i++) {
					if(parseInt(d.cart[i].id)==parseInt(photo) && parseInt(d.cart[i].type)==parseInt(v)) { return d.cart[i].count; }				
				}
			}
		}
		return 0;
	}
	
	function showImg(i) { img=i; }
	
onMount(() => {
    const storedMaterial = localStorage.getItem('material');
    if (storedMaterial) {
	material = storedMaterial;
    }
  });
	
 $: {
 	if(needUpdate) { updateData(); }
 }
</script>
<svelte:head>
    <meta name="robots" content="noindex, nofollow" />
</svelte:head>
{#await data}
	<Loading />
{:then data}
  {#if data.album === undefined || !data.album || data.album.length == 0}
  	<div class="w-full p-4 px-mobile pb-4">
           <Card body class="p-4">
            <div class="warning" style="font-weight:bold;">Neexistující číslo objednávky nebo zakázka již expirovala. Zkuste prosím upravit číslo zakázky...</div><br /><br />
            	<form on:submit|preventDefault={handleOpenOrder}>
			<Textfield type="text" label="Zadejte číslo zakázky" name="code" bind:value={orderno} required class="codeInput" />
			<Button color="{orderno ? "primary" : "secondary"}" outlined on:click={openOrder}>Otevřít zakázku</Button>
		</form>
           </Card>
         </div>
  {:else}
	<br /><br />
	<div class="buttons">
		<Tooltip text="Sdílet zakázku" placement="left">
			<span class="button" on:click="{()=>SendMailOpen=true}" id="shareBtn"><Icon name="share-fill" /></span>
		</Tooltip>
		&nbsp;
		{#if token}
			&nbsp;
			<Tooltip text="Odstranit zakázku" placement="left">
				<span class="button" on:click="{()=>deleteOrderOpen=true}" id="shareBtn"><Icon name="trash" /></span>
			</Tooltip>&nbsp;
		{/if}
	</div><br />
	{#if data.album !== 'null'}
		{#if data.album[0].nazev}
			<h2 class="photoHeader">Číslo zakázky: {data.album[0].nazev}</h2>
		{/if}
	{:else}
		<h2 class="photoHeader">{data.school.nazev}</h2>
	{/if}
	<div class="img-boxes mgt">
	{#each data.foto as ph, z}
		<div class="img-box">
			<Card body>
			  <div>
				<img src="{$path}{data.config.folderPhoto}/{ph.file}" style="max-width:500px;" alt="" loading="lazy" nosave on:contextmenu|preventDefault={onRightClick} on:click="{()=>showImg($path+data.config.folderPhoto+'/'+ph.file)}" align="left" />
				<div class="right" style="margin-left:20px; width:300px; max-width:70vw;">
					
					<b>{removeSuffix(ph.file)}</b><br /><br />

					<table class="w-full border-collapse border border-gray-300 shadow-lg">
					  <!--<thead>
					    <tr class="bg-gray-100 text-left">
					      <th class="px-4 py-2 border border-gray-300">Formát</th>
					      <th class="px-4 py-2 border border-gray-300">Počet</th>
					    </tr>
					  </thead>-->
					  <thead>
					    <tr class="bg-gray-100 text-left">
					      <th class="px-4 py-2 border border-gray-300" colspan="3"><i>Vyberte formát a počet:</i></th>
					    </tr>
					  </thead>
					  <tbody class="divide-y divide-gray-300">
					    <tr class="hover:bg-gray-50 {isSelected(ph.id, varId['10x15'], data, dataCart)}">
					      <td class="ps-4">10x15 cm</td>
					      <td class="warning ps-1">
					      	{#if getMaxPrintSize(ph.width, ph.height)<15.5}
					      		<Tooltip text="Fotografie nemá dostatečnou kvalitu pro uvedený formát tisku"><Icon name="exclamation-triangle" /></Tooltip>
					      	{/if}
					      	{#if ph.width!==null && getAspectRatio(ph.width, ph.height)!="3:2"}
					      		<Tooltip text="Fotografie bude oříznuta na odpovídající poměr stran"><Icon name="crop" /></Tooltip>
					      	{/if}
					      </td>
					      <td class="px-2"><NumberSpinner bind:orderno file={ph.file} photoId={ph.id} count={getCountFromCart(ph.id, varId['10x15'], data)} variant={varId['10x15']} bind:dataCart /></td>
					    </tr>
					    <tr class="hover:bg-gray-50 {isSelected(ph.id, varId['13x18'], data, dataCart)}">
					      <td class="ps-4">13x18 cm</td>
					      <td class="warning ps-1">
					      	{#if getMaxPrintSize(ph.width, ph.height)<18}
					      		<Tooltip text="Fotografie nemá dostatečnou kvalitu pro uvedený formát tisku"><Icon name="exclamation-triangle" /></Tooltip>
					      	{/if}
					      	{#if ph.width!==null && getAspectRatio(ph.width, ph.height)!="18:13"}
					      		<Tooltip text="Fotografie bude oříznuta na odpovídající poměr stran"><Icon name="crop" /></Tooltip>
					      	{/if}
					      </td>
					      <td class="px-2"><NumberSpinner bind:orderno file={ph.file} photoId={ph.id} count={getCountFromCart(ph.id, varId['13x18'], data)} variant={varId['13x18']} bind:dataCart /></td>
					    </tr>
					    <tr class="hover:bg-gray-50 {isSelected(ph.id, varId['15x20'], data, dataCart)}">
					      <td class="ps-4">15x20 cm</td>
					      <td class="warning ps-1">
					      	{#if getMaxPrintSize(ph.width, ph.height)<20.3}
					      		<Tooltip text="Fotografie nemá dostatečnou kvalitu pro uvedený formát tisku"><Icon name="exclamation-triangle" /></Tooltip>
					      	{/if}
					      	{#if ph.width!==null && getAspectRatio(ph.width, ph.height)!="4:3"}
					      		<Tooltip text="Fotografie bude oříznuta na odpovídající poměr stran"><Icon name="crop" /></Tooltip>
					      	{/if}
					      </td>
					      <td class="px-2"><NumberSpinner bind:orderno file={ph.file} photoId={ph.id} count={getCountFromCart(ph.id, varId['15x20'], data)} variant={varId['15x20']} bind:dataCart /></td>
					    </tr>
					    <tr class="hover:bg-gray-50 {isSelected(ph.id, varId['20x30'], data, dataCart)}">
					      <td class="ps-4">
					      	20x30 cm</td>
					      <td class="warning ps-1">
					      	{#if getMaxPrintSize(ph.width, ph.height)<30.5}
					      		<Tooltip text="Fotografie nemá dostatečnou kvalitu pro uvedený formát tisku"><Icon name="exclamation-triangle" /></Tooltip>
					      	{/if}
					      	{#if ph.width!==null && getAspectRatio(ph.width, ph.height)!="3:2"}
					      		<Tooltip text="Fotografie bude oříznuta na odpovídající poměr stran"><Icon name="crop" /></Tooltip>
					      	{/if}
					      </td>
					      <td class="px-2"><NumberSpinner bind:orderno file={ph.file} photoId={ph.id} count={getCountFromCart(ph.id, varId['20x30'], data)} variant={varId['20x30']} bind:dataCart /></td>
					    </tr>
					  </tbody>
					</table>
					{#if getMaxPrintSize(ph.width, ph.height)<30.5}
						<div class="py-2 notice">Pro označené rozměry <span class="warning"><Icon name="exclamation-triangle" /></span>&nbsp;&nbsp;nemá fotografie dostatečnou kvalitu. Pravděpodobně nebude ostrá.</div>
					{/if}
				</div>
			  </div>
			</Card>
		</div>
	{/each}
	{#if token}
		<div class="img-box">
			<Card body>
			  <div>
			  	<h3><Icon name="plus-circle" /> Nahrát další fotografie?</h3>
			  	<Imgupload bind:orderno reload=true bind:needUpdate bind:token />
			  </div>
			</Card>
		</div>
	{/if}
	</div>
	{#if success}
		<Alert color="primary" heading="Děkujeme za Vaší objednávku!">
		 	Ve Vašem e-mailu naleznete další informace.
		</Alert>
	{/if}
	<div class="sum-box">
		<Card body>
			<h3>Shrnutí objednávky</h3>
			
			<b>Číslo zakázky:</b>{orderno}
			<a href="#" on:click|preventDefault="{()=>SendMailOpen=true}">odeslat odkaz do e-mailu</a><br />
			<div class="py-4 notice">Označené rozměry <span class="warning"><Icon name="crop" /></span>&nbsp;&nbsp;budou automaticky oříznuty na odpovídající poměr stran. Chcete-li předejít automatickému ořezu - nahrajte prosím fotografii znovu v poměru stran odpovídající požadovanému formátu.</div>
			
			<b><br />Vyberte materiál: </b> 
			<div style="max-width:360px;margin:auto;">
			<Input type="select" bind:value={material} on:change="{(e)=>changeMaterial(e.target.value, data)}">
				<option value="mat">MAT</option>
				<option value="matr">MAT se 4mm bílým okrajem (kromě 20x30)</option>
				<option value="lesk">LESK</option>
				<option value="leskr">LESK se 4mm bílým okrajem (kromě 20x30)</option>
			</Input>
			</div>
			
			<b><br />Celková cena:</b> 
			{calcPrice(dataCart, data)},-Kč<br />
		
			
			{#if calcPrice(dataCart, data)}
				<div class="sum-button">
					<Button color="primary" size="lg" on:click="{()=>openConfirmDialog=true}">Vybrat dopravu a objednat fotografie</Button>
				</div>
			{/if}
			<br /><br /><br />
		</Card>
	</div>
  {/if}
{/await}
  <ImgDialog bind:img />
  <ConfirmDialog bind:open="{openConfirmDialog}" totalPrice={calcPrice(dataCart, data)} bind:success bind:needUpdate />
  <SendEmail bind:open={SendMailOpen} bind:orderno />
  <DeleteOrder bind:open={deleteOrderOpen} bind:orderno bind:token />

<style>
	.photoHeader { position:relative; top:-30px; }
	.mgt { margin-top:15px; }
	.psrelminus { position:relative; top:-25px; }
	.img-boxes { display: flex; align-items: stretch; justify-content: space-around; flex-wrap:wrap; }
	.img-box { /*max-width:500px;*/ float:left; margin:auto 0 7px; border:1px solid transparent; border-radius: 5px; }
	.img-box img { margin:auto; width:auto; height:auto; max-width:70vw; max-height:310px; }
	.img-box-big img { max-width:99vw; max-height:99vh; }
	.sum-box { max-width:600px; margin:20px auto; border:1px solid transparent; border-radius: 5px; text-align:center; font-size:18px; }
	.sum-box h3 { padding:10px 0 35px; }
	.sum-box b { display:inline; }
	.sum-button { padding:35px 0 15px; }
	.left { float:left; width:100px; }
  	.right { float:right; width:80px; }
  	.warning { color:darkred; font-size:20px; }
  	.notice { font-style:italic; font-size:13px; }
  	.selected { background-color:rgba(255,255,153, 0.7); }
	.mgauto { margin:auto; }
	.click { cursor: pointer; }
	.img-box-small { width:260px; float:left; margin:auto 6px 7px; /*height:115px;*/ border:1px solid transparent; border-radius: 5px; }
	.img-box-small img { float:left; width:auto; height:auto; max-width:95px; max-height:80px; }
	.downloadIcon { text-align:right; font-size:28px; }
	.selectedBox { border:1px solid red; border-radius: 5px; }
	.inCartBox { border:1px solid green; border-radius: 5px; }
	.cartButton { position:fixed; bottom:10px; right:20px; padding-left:10px; background-color:white; font-size:20px; }
	.buttons { float:right; text-align:right; font-size:25px; z-index:10; }
	.button { border:1px solid rgba(0,0,0,.125); border-radius: calc(.25rem - 1px); padding:5px; cursor: pointer; }
	input[type=checkbox] { transform: scale(1.4); }
</style>
